// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-card {
  margin:0.5em 0;
}

mat-card-header {
  padding:0.5rem 1rem;
}

.list .item:last-child .separator {
  display:none;
}
.header button {
  padding:0.25em 0.75em;
}
.header button, .action button {
  width:100%;
  display:inline-block;
}
.action button {
  padding:0.25em 0.75em;
}
.information {
  width:100%;
  border-top:1px solid #ddd;
}
.stats, .documents, .related-products, .image {
  display:inline-block;
  padding:1em;
  vertical-align: top;
  width:100%;
}

.image {
  border-radius:5px;
  border:1px solid #ddd;
  box-shadow: #ddd 0.5em 0.5em 0.5em;
}
.image img {
  width:100%;
  height:100%;
}
.material-icons.full {
  display:none;
}

.action button.remove:hover {
  background:#fee;
}
.action button.remove mat-icon.hover {
  display:none;
}
.action button.remove:hover mat-icon.hover {
  display:inline-block;
}
.action button.remove:hover mat-icon.del {
  display:none;
}
.action button.add:hover {
  background:#efe;
}

@media only screen and (min-width:30em) {
  .header {
    display:inline-block;
    width:50%;
    vertical-align:top;
  }
  .header button {
    text-align:left;
  }
  .action {
    vertical-align:top;
    display:inline-block;
    width:50%;
    text-align:right;
  }
  .action button {
    width:auto;
  }
}

@media only screen and (min-width:50em) {
  .information .documents, .information .related-products {
    width:50%;
  }
  .material-icons.small {
    display:none;
  }
  .material-icons.full {
    display:inline-block;
  }
}

@media only screen and (min-width:80em) {
  .information .stats {
    width:40%
  }
  .information .image {
    float:right;
    margin-top:1em;
    width:55%;
  }
  .information .documents, .information .related-products {
    width:29%;
  }
  .information::after {
    content: ' ';
    display:block;
    clear:both;
  }
}

`, "",{"version":3,"sources":["webpack://./src/app/pages/submittal/build-submittal/firestop-card/firestop-card.component.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;AACA;EACE,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,kCAAkC;AACpC;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,oBAAoB;AACtB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,oBAAoB;IACpB,SAAS;IACT,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,oBAAoB;IACpB,SAAS;IACT,gBAAgB;EAClB;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,SAAS;EACX;EACA;IACE,YAAY;EACd;EACA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE;EACF;EACA;IACE,WAAW;IACX,cAAc;IACd,SAAS;EACX;EACA;IACE,SAAS;EACX;EACA;IACE,YAAY;IACZ,aAAa;IACb,UAAU;EACZ;AACF","sourcesContent":["mat-card {\n  margin:0.5em 0;\n}\n\nmat-card-header {\n  padding:0.5rem 1rem;\n}\n\n.list .item:last-child .separator {\n  display:none;\n}\n.header button {\n  padding:0.25em 0.75em;\n}\n.header button, .action button {\n  width:100%;\n  display:inline-block;\n}\n.action button {\n  padding:0.25em 0.75em;\n}\n.information {\n  width:100%;\n  border-top:1px solid #ddd;\n}\n.stats, .documents, .related-products, .image {\n  display:inline-block;\n  padding:1em;\n  vertical-align: top;\n  width:100%;\n}\n\n.image {\n  border-radius:5px;\n  border:1px solid #ddd;\n  box-shadow: #ddd 0.5em 0.5em 0.5em;\n}\n.image img {\n  width:100%;\n  height:100%;\n}\n.material-icons.full {\n  display:none;\n}\n\n.action button.remove:hover {\n  background:#fee;\n}\n.action button.remove mat-icon.hover {\n  display:none;\n}\n.action button.remove:hover mat-icon.hover {\n  display:inline-block;\n}\n.action button.remove:hover mat-icon.del {\n  display:none;\n}\n.action button.add:hover {\n  background:#efe;\n}\n\n@media only screen and (min-width:30em) {\n  .header {\n    display:inline-block;\n    width:50%;\n    vertical-align:top;\n  }\n  .header button {\n    text-align:left;\n  }\n  .action {\n    vertical-align:top;\n    display:inline-block;\n    width:50%;\n    text-align:right;\n  }\n  .action button {\n    width:auto;\n  }\n}\n\n@media only screen and (min-width:50em) {\n  .information .documents, .information .related-products {\n    width:50%;\n  }\n  .material-icons.small {\n    display:none;\n  }\n  .material-icons.full {\n    display:inline-block;\n  }\n}\n\n@media only screen and (min-width:80em) {\n  .information .stats {\n    width:40%\n  }\n  .information .image {\n    float:right;\n    margin-top:1em;\n    width:55%;\n  }\n  .information .documents, .information .related-products {\n    width:29%;\n  }\n  .information::after {\n    content: ' ';\n    display:block;\n    clear:both;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
